/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S10_P1_AInputs */

const tr_kullanim_s10_p1_a = /** @type {(inputs: Kullanim_S10_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse®, Kullanıcı'nın Platform'a yüklediği kişisel veriler bakımından veri işleyen; kendi kullanıcılarından topladığı bilgiler bakımından veri sorumlusu sıfatıyla hareket eder. Ayrıntılı aydınlatma`)
};

const en_kullanim_s10_p1_a = /** @type {(inputs: Kullanim_S10_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® acts as a data processor with regard to the personal data uploaded to the Platform by the User, and as a data controller with regard to the information it collects from its own users. Detailed information is available on our`)
};

const de_kullanim_s10_p1_a = /** @type {(inputs: Kullanim_S10_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® handelt hinsichtlich der vom Nutzer auf die Plattform hochgeladenen personenbezogenen Daten als Auftragsverarbeiter und hinsichtlich der von den eigenen Nutzern erhobenen Angaben als Verantwortlicher. Die ausführliche Aufklärung können Sie auf unserer Seite`)
};

const ru_kullanim_s10_p1_a = /** @type {(inputs: Kullanim_S10_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® выступает обработчиком данных в отношении персональных данных, загружаемых Пользователем на Платформу, и оператором данных в отношении сведений, собираемых от собственных пользователей. Подробное уведомление размещено на странице`)
};

/**
* | output |
* | --- |
* | "Emonse® acts as a data processor with regard to the personal data uploaded to the Platform by the User, and as a data controller with regard to the informati..." |
*
* @param {Kullanim_S10_P1_AInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s10_p1_a = /** @type {((inputs?: Kullanim_S10_P1_AInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S10_P1_AInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s10_p1_a(inputs)
	if (locale === "de") return de_kullanim_s10_p1_a(inputs)
	if (locale === "ru") return ru_kullanim_s10_p1_a(inputs)
	return tr_kullanim_s10_p1_a(inputs)
});